import { render, staticRenderFns } from "./LocationForm.vue?vue&type=template&id=989dff0e"
import script from "./LocationForm.vue?vue&type=script&lang=js"
export * from "./LocationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports